import React from 'react';
import './PhishingIcon.css';

const paths = {
  copy: <><rect x="8" y="8" width="12" height="13" rx="2" /><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3" /></>,
  check: <path d="m5 12 4 4L19 6" />,
  dashboard: <><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>,
  delivery: <><path d="M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6l-8-3Z" /><path d="m8 12 3 3 5-6" /></>,
  campaigns: <path d="m3 11 18-8-8 18-2-8-8-2Zm8 2 10-10" />,
  templates: <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 7h8M8 11h8M8 15h5" /></>,
  users: <><circle cx="9" cy="8" r="3" /><path d="M3 20v-2a6 6 0 0 1 12 0v2m1-15a3 3 0 0 1 0 6m2 3a5 5 0 0 1 3 4v2" /></>,
  smtp: <><rect x="3" y="3" width="18" height="7" rx="2" /><rect x="3" y="14" width="18" height="7" rx="2" /><path d="M7 6.5h.01M7 17.5h.01M12 6.5h5m-5 11h5" /></>
};

export function phishingMenuIcon(path = '') {
  if (typeof path !== 'string') return null;
  const pathname = `/${path.replace(/^\/+/, '')}`.split(/[?#]/)[0].replace(/\/+$/, '');
  const base = '/organization/phishing_simulator';
  if (pathname === base) return 'dashboard';
  if (pathname === `${base}/phishing_campaign` || pathname.startsWith(`${base}/phishing_campaign/`) || pathname === `${base}/simulations`) return 'campaigns';
  if (['templates', 'landingpage', 'emailtemplate'].some(section => pathname === `${base}/${section}`)) return 'templates';
  if (pathname === `${base}/usersandgroups`) return 'users';
  if (pathname === `${base}/smtpconfig`) return 'smtp';
  if (pathname === `${base}/delivery-settings` || pathname.startsWith(`${base}/delivery-settings/`)) return 'delivery';
  return null;
}

export default function PhishingIcon({ name }) {
  if (!paths[name]) return null;
  return <svg className={`phishing-icon phishing-icon--${name}`} viewBox="0 0 24 24" width="24" height="24" fill="none"
    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{paths[name]}</svg>;
}
